import type React from 'react';

interface Props {
  label?: string;
  children: React.ReactNode;
}

const VerktoyInfoElement = ({ label, children }: Props): React.JSX.Element => {
  return (
    <>
      <div className="verktoy__infoElement_heading">{label}</div>
      {children}
    </>
  );
};

export default VerktoyInfoElement;
